import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const mobileImage: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'mobui_MobuiImage_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'MobuiImageRole',
      bindings: [
        {
          title: 'mobui_MobuiImage_dataBinding_src_label',
          prop: 'src',
          supportedFieldTypes: [FieldType.image],
          defaultFieldType: FieldType.image,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
